import { render, staticRenderFns } from "./AddPannars.vue?vue&type=template&id=55e21084&scoped=true&"
import script from "./AddPannars.vue?vue&type=script&lang=js&"
export * from "./AddPannars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e21084",
  null
  
)

export default component.exports